import { useTranslation } from "react-i18next";
import SectionHeader from "../../../util/component/SectionHeader";
import { Route, Routes } from "react-router-dom";
import Payment from "./payments/sections/Payment";
import PaymentTools from "./payments/pages/PaymentTools";
import PaymentRequest from "./payments/pages/PaymentRequest";
import PaymentRequestDetail from "./payments/pages/PaymentRequestDetail";
import Cards from "./amex/sections/Cards";
import Reports from "./amex/sections/Reports";
import CardsWizard from "./amex/sections/CardsWizard";
import Transactions from "./amex/sections/Transactions";
import { useHasScope } from "../../../config/globalConfig";
import NotAuthorizedDialog from "../../authentication/component/NotAuthorizedDialog";
import {OUTSTANDING_VIEW, OUTSTANDING_VIEW_FROM_CB, PAYMENT_REQUEST_SM_VIEW, PAYMENT_REQUEST_VIEW} from "../utils/FinanceScope";


const PagePayments = () => {
  const { t } = useTranslation(["finance"], { keyPrefix: "payments" });
  const hasScope = useHasScope;
  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <SectionHeader
              title={t("header.title")}
              subtitle={t("header.subtitle")}
            />
            <Payment />
          </>
        }
      />
      <Route
        path="/tools"
        element={
          <>
            <SectionHeader
              title={t("tools.header.title")}
              subtitle={t("tools.header.subtitle")}
            />
            <PaymentTools />
          </>
        }
      />
      <Route
        path="/amex/cards"
        element={
          <>
            <SectionHeader
              title={t("amex.cards.header.title")}
              subtitle={t("amex.cards.header.subtitle")}
            />
            <Cards />
          </>
        }
      />
      <Route
        path="/amex/transactions"
        element={
          <>
            <SectionHeader
              title={t("amex.transactions.header.title")}
              subtitle={t("amex.transactions.header.subtitle")}
            />
            <Reports />
          </>
        }
      />
      <Route path="/amex/transactions/wizard/:id/:name" element={
        <>
          <SectionHeader title={t('amex.transactions.pages.wizard.header.title')} subtitle={t('amex.transactions.pages.wizard.header.subtitle')} />
          <Transactions />
        </>
      } />
      <Route path="/amex/cards/wizard" element={
        <>
          <SectionHeader title={t('amex.cards.pages.wizard.header.title')} subtitle={t('amex.cards.pages.wizard.header.subtitle')} />
          <CardsWizard type={'CREATE'} />
        </>
      } />
      <Route path="/amex/cards/wizard/:id" element={
        <>
          <SectionHeader title={t('amex.cards.pages.wizard.header.title')} subtitle={t('amex.cards.pages.wizard.header.subtitle')} />
          <CardsWizard type={'UPDATE'} />
        </>
      } />
      <Route
        path="/payment-request"
        element={
          hasScope(PAYMENT_REQUEST_VIEW) || hasScope(PAYMENT_REQUEST_SM_VIEW) ? (
            <>
              <SectionHeader
                title={t("payment-request.header.title")}
                subtitle={t("payment-request.header.subtitle")}
              />
              <PaymentRequest outstanding={false}/>
            </>
          ) : <NotAuthorizedDialog />
        }
      />
      <Route path="/payment-request/:id"
        element={
          <>
            <SectionHeader
              title={t("payment-request.header.title")}
              subtitle={t("payment-request.header.subtitle")}
            />
            <PaymentRequestDetail outstanding={false}/>
          </>
        } />
        <Route
            path="/outstanding-management"
            element={
                (hasScope(OUTSTANDING_VIEW) || hasScope(OUTSTANDING_VIEW_FROM_CB)) ? (
                    <>
                        <SectionHeader
                            title={t("payment-request.header.titleOutstanding")}
                            subtitle={t("payment-request.header.subtitleOutstanding")}
                        />
                        <PaymentRequest outstanding={true}/>
                    </>
                ) : <NotAuthorizedDialog />
            }
        />
        <Route path="/outstanding-management/:id"
               element={
                   <>
                       <SectionHeader
                           title={t("payment-request.header.titleOutstanding")}
                           subtitle={t("payment-request.header.subtitleOutstanding")}
                       />
                       <PaymentRequestDetail outstanding={true}/>
                   </>
               } />
    </Routes>
  );
};

export default PagePayments;
